export enum CampaignStatusEnum {
  Active = 1,
  Deactive = 2,
  Finished = 3
}
